module.exports = __webpack_public_path__ + "static/media/mouthFrownLeft.12a47933.obj";